module.exports = __webpack_public_path__ + "img/s-cross-banner.b88b9c52.svg";